function isEllipsisActive(element, offset = 0) {
  return element.offsetWidth < element.scrollWidth - offset || element.offsetHeight < element.scrollHeight - offset;
}
function isAvailableElement(element) {
  const ariaDisabledAttribute = element.getAttribute("aria-disabled");
  const isDisabled = element.hasAttribute("disabled");
  const isAriaDisabled = ariaDisabledAttribute !== null && ariaDisabledAttribute === "true";
  const isHidden = element.hasAttribute("hidden");
  return !isDisabled && !isAriaDisabled && !isHidden;
}

export { isAvailableElement, isEllipsisActive };
//# sourceMappingURL=element.mjs.map
